import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import NextLink from 'next/link';

import { Artist } from '@definitions/artworks.types';
import { PointTitle } from '@components/PDP/pdp.styles';
import { ROUTE } from '@utils/constants';
import { getFullArtistName } from '@utils/helpers';
import { ReadMoreButton } from '@components/readMoreButton';

import { Container, ArtistName, ArtistBiography, Content, ArtistBiographyWrapper } from './artworkArtist.styles';

export interface ArtworkArtistProps {
  artist: Artist;
  additionalArtistBiography: string;
}

export const ArtworkArtist = ({ artist, additionalArtistBiography }: ArtworkArtistProps) => {
  const intl = useIntl();
  const slug = `${ROUTE.ARTISTS.substring(1)}/${artist.slug}`;
  const {
    biography: { paragraph },
    artistParagraph,
  } = artist;

  function formatBiography(paragraph: string, additionalBio: string, artistParagraph: string | Record<string, never>) {
    return `${paragraph}${additionalBio || ''}${typeof artistParagraph === 'string' ? artistParagraph : ''}`;
  }

  return (
    <Container>
      <PointTitle>
        <FormattedMessage id="artworkArtist.pointTitle" defaultMessage="③ Artist:" />
      </PointTitle>
      <Content>
        <NextLink href={`${ROUTE.ARTISTS}/${artist.slug}`} passHref>
          <ArtistName>{getFullArtistName(artist)}</ArtistName>
        </NextLink>
        <ArtistBiographyWrapper>
          <ArtistBiography
            dangerouslySetInnerHTML={{
              __html: formatBiography(paragraph, additionalArtistBiography, artistParagraph),
            }}
          />
          <ReadMoreButton
            slug={slug}
            displayText={intl.formatMessage({
              id: 'artworkArtist.readMoreLinkDefaultText',
              defaultMessage: 'Read more',
            })}
          />
        </ArtistBiographyWrapper>
      </Content>
    </Container>
  );
};
